import React, { Component, PureComponent } from 'react';
import _ from 'lodash';

import ContentFormData from '../../types/ContentFormData';
import ContentFormDataError from '../../types/ContentFormDataError';
import { CreateContentContentTagData } from '../../types/ContentTagData';

import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
    WithStyles,
    createStyles,
    Typography,
    Grid,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Checkbox,
    FormGroup,
    FormControlLabel,
    TextField
} from '@material-ui/core';

import {
    MyPATExpansionPanel, AwardGraceMarks, MyPATSelect
} from '../../../common';

import { statusType } from '../../types/ContentInSection'
import AddFeedback from '../../../content-request/components/AddFeedback';
import { SectionFocusedContext, SectionFocusedContextValue } from '../../../common/MyPATBaseSection';
import SetIdealTime from './SetIdealTime';
import CustomInfoIcon from '../../../common/CustomInfoIcon';
import { SECTIONS } from '../../helper/contentValidation';
import AddFeedbackPopup from './AddFeedbackPopup';

const styles = (theme: Theme) => createStyles({
    feedbackContainer: {
		position: 'relative',
		'& .feedbackBlock': {
		  top: -16,
		  left: "100%",
		  position: "absolute",
		  marginLeft: 20,
		  zIndex: 2
		}
	  },
    attentionTitle: {
        fontSize: '16px',
        'font-weight': '500',
        lineHeight: '15px',
        textAlign: 'center',
        letterSpacing: '0.144385px',
        color: '#000000',
        display: 'block',
        paddingBottom: '18px',
    },
    blueColor: {
		color: '#1D7DEA'
	},

    borderBox: {
        border: '1px solid #E1E1E1',
        boxSizing: 'border-box',
        borderRadius: 5,
        backgroundColor: '#fff',
        padding: 8,
        overflow: 'auto'
    },

    mb2x: {
        marginBottom: theme.spacing.unit * 2,
    },

    cardHeading: {
        fontWeight: theme.typography.fontWeightRegular,
    },



    checkboxChecked: {
        color: '#59CA1C !important',
    },

    adornedReorder: {
        cursor: 'move',
        height: theme.spacing.unit * 4.5,
        padding: `0 ${theme.spacing.unit}px`,
        maxHeight: 'unset',
        borderRight: `1px solid ${theme.palette.grey[300]}`,
        '& svg': {
            fontSize: theme.spacing.unit * 3,
            color: theme.palette.grey[500],
        }
    },

    answerTable: {
        width: 'auto',
        marginLeft: '20px',
        '& tbody': {
            '& tr': {
                height: 'auto',
                '& td': {
                    padding: `${theme.spacing.unit / 2}px 0`,
                    border: 0,
                    textAlign: 'center',
                    fontSize: '20px',
                    lineHeight: '38px',
                    color: '#333',
                    minWidth: theme.spacing.unit * 10,
                    '&:first-child': {
                        minWidth: 'auto',
                        fontSize: '20px',
                        lineHeight: '38px',
                        color: '#333',
                    },
                    '&:last-child': {
                        paddingRight: 0,
                    },
                },
            },
        },
    },

    "math-editor-workplace-container": {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100vh",
        background: "#000000",
        Opacity: ".7",
        'z-index': "9999",
    },

    deleteVBtn: {
        border: `1px solid ${theme.palette.grey[300]}`,
        visibility: 'visible',
        '& svg': {
            color: theme.palette.grey[600],
        },

    },
    optionIdGrid: {
        minWidth: theme.spacing.unit * 4,
    },
    paddingSet: {
        padding: '0 15px 0 0',
    },
    popupBlock: {
        width: '450px',
        textAlign: 'center',
        '& p': {
            fontSize: '16px',
            'font-weight': 'normal',
            lineHeight: '16px',
            textAlign: 'center',
            letterSpacing: '0.144385px',
            color: '#000000',
            display: 'block',
            paddingTop: '20px',
        }
    },
    // answer Setting
    subTitle:{
        fontSize: 16,
        lineHeight:'22px',
        color: '#333',
        margin: '6px 0 30px 6px'
    },
    checkedCheckbox: {
		backgroundColor: '#30BE76',
		border: '1px solid #30BE76 !important',
		borderRadius: 2,
		color: '#99a1a7',
		'&::after': {
			content: "''",
			fontSize: 14,
			position: 'absolute',
			top: 3,
			left: 8,
			width: 4,
			height: 12,
			border: 'solid #fff',
			borderWidth: '0 2px 2px 0',
			transform: 'rotate(45deg)'
		},
		'&:hover': {
			backgroundColor: '#30BE76'
		}
    },
    checkBoxElement: {
		padding: '0px 7px',
		top: 0,
		width: 24,
		height: 24,
		'-moz-appearance': 'none',
		opacity: 1,
		color: 'rgb(204, 204, 204)',
		border: '1px solid #B2B2B2',
		borderRadius: 2,
		margin: '-4px 14px 0px 16px',
		'& svg': {
			fontSize: '1.5rem',
			fontFamily: '"Nunito", sans-serif',
			fill: '#979797',
			opacity: 0
		},
        '& span:nth-child(1)': {
            width: 24,
            zIndex: 9
        }
    },
    primaryColor: {
		color: 'rgb(29 125 234)'
    },
    setAnswerContainer:{
        marginBottom: '20px',
    },
    // End
    spacingMD: {
        width: 'calc(100% + 30px)',
        margin: '-10px 0px 0px',
        padding: '0px 8px'
    },

    requiredHeading: {
        color: theme.palette.secondary.main,
    },
    // set ideal time
    optionContainerTxt:{
        margin: '24px 0 0px 0px',
    },
    posRelative:{
        position: 'relative'
    },
    arrowIcon:{
        position: 'absolute',
        right: '8px',
        zIndex: 99,
        top: '1px',
    },
    arrowIconT:{
        cursor: 'pointer'
    },
    arrowIconB:{
        marginTop: '-10px',
        cursor: 'pointer',
    },
    headingTxt:{
        fontSize: '14px',
        lineHeight: '16px',
        color: '#333',
    },
    grayTxt:{
        color: '#999'
    },
    optionSettingText : {
        width: "83px",
        margin: "0px 10px 0 10px",
        textAlign: 'center',
        "& input": {
          padding: "10px",
        },
        "& input[type=number]::-webkit-inner-spin-button, & input[type='number'].mod::-moz-inner-spin-button, & input[type=number]::-webkit-outer-spin-button, & input[type='number'].mod::-moz-outer-spin-button": {
          opacity: 0
        },
        "& input[type=number]":{
            '-moz-appearance': 'textfield',
            'appearance': 'none',
        },
      },
      feedbackHighlight:{
        cursor: 'pointer',
        '&:hover':{
          color: '#1d7dea',
        }
      },

});

const optionsIdSet: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
let sections = ['questionContent', 'matrixOptionContent', 'correctAnswer', 'solutionContent', 'questionHints', 'tags', 'conceptCode'];

interface MatrixAnswersProps extends WithStyles<typeof styles> {
    type: string,
    subType: string,
    formData: ContentFormData,
    formDataError: ContentFormDataError,
    changeHandler: Function,
    handleFormChange: Function,
    eventFired: Function,
    history: any;
    updateContent: Function,
    matrixCorrectAnswer: any,
    matrixOptionContent: any,
    idealTime: any,
    onChangeIdealTime: Function,
    error: boolean,
    errorText: string,
    tag: string,
    openFeedback: boolean,
    addFeedback: Function,
    replyFeedback: Function,
    closeFeedback: Function,
    resolveFeedback: Function,
    clickedfeedbackData: any,
    addNewFeedback: Function,
    authorType?: string,
    isDisable: boolean,
    isIdealTimeDisabled: boolean;
    hideIdealTIme?: boolean;
    sectionId? : string;
    activeValidationFeedbackSection?: string;
    activeValidationFeedbackData?: number;
    handleAddCommentInFeedback?: Function;
    createNewValidationFeedback?: Function;
}

interface MatrixAnswersState { }

class MatrixAnswers extends PureComponent<MatrixAnswersProps, MatrixAnswersState> {

    constructor(props: MatrixAnswersProps) {
        super(props);
        this.handleCorrectOptionChange = this.handleCorrectOptionChange.bind(this);
    }

    componentDidMount() {
        // const self = this
        /* TODO: uncomment later when data loss issue fix for all functions */
        // const {formData} = this.props
        // self.props.updateContent(formData)
        // window.onbeforeunload = function (e: any) {
        //     const { matrixCorrectAnswer, matrixOptionContent } = self.props;
        //     const matrixCorrectAnswerCopy: any = JSON.parse(JSON.stringify(matrixOptionContent))
        //     //const { formData } = self.props
        //     // self.props.updateContent(formData)
        //     self.props.handleFormChange(matrixCorrectAnswerCopy)
        //     e.preventDefault()
        //     e.returnValue = ''
        // }
    }

    eventChanges(name: any) {
        if (sections.includes(name))
            this.props.eventFired(name, statusType.edit, 0, 0);
    }

    handleCorrectOptionChange = (optionLId: string, optionRId: string, evt: any, checked: boolean) => {
        const { matrixCorrectAnswer, matrixOptionContent } = this.props;
        const matrixCorrectAnswerCopy: any = JSON.parse(JSON.stringify(matrixCorrectAnswer))
        let caData: any[] = _.get(matrixCorrectAnswerCopy, 'data', []);
        let caIdx: any = _.findIndex(caData, ['id', optionLId]);

        if (checked) {
            if (caIdx < 0) {
                caData.push({
                    value: [optionRId],
                    weightage: '2',
                    id: optionLId,
                })
            } else {
                caData[caIdx].value.push(optionRId);
            }
        } else {
            const valIdx = caData[caIdx].value.indexOf(optionRId);
            caData[caIdx].value.splice(valIdx, 1);
        }
        // this.props.updateContent(formData)
        matrixCorrectAnswerCopy.data = caData
        this.props.changeHandler(matrixCorrectAnswerCopy);
        //this.eventChanges("correctAnswer");
    }

    isChecked = (optionLId: any, optionRId: any) => {
        const { matrixCorrectAnswer, matrixOptionContent } = this.props;
        const matrixCorrectAnswerCopy: any = JSON.parse(JSON.stringify(matrixCorrectAnswer))
        // const { formData } = this.props;
        let hasChecked = false;
        const caData: any[] = _.get(matrixCorrectAnswerCopy, 'data', []);

        const leftOptionSet = _.find(caData, ['id', optionLId]);
        if (!_.isUndefined(leftOptionSet)) {
            hasChecked = _.includes(leftOptionSet.value, optionRId);
        }

        return hasChecked;
    }

    onChangeIdealTime = (e: any, newState?: number) => {
        var regex = /^\d+$/
        let value = e ? e.target.value : this.props.idealTime.value
        if(value === '' || regex.test(value)) {
            value = value ? parseInt(value) : value
            let {state} = this.props.idealTime
            if(newState) {
                state = newState
            }
            if(state >= 1 && state <= 3) {
                this.props.onChangeIdealTime(value, state)
            }
        }
    }

    renderIdealTimeState() {
        const {idealTime} = this.props
        if(idealTime.state === 2) {
            return 'Min'
        } else if(idealTime.state === 3) {
            return 'Hour'
        } else if(idealTime.state === 1) {
            return 'Sec'
        }
    }

    render() {
        let { classes, matrixOptionContent, idealTime, error, errorText, isIdealTimeDisabled, hideIdealTIme, activeValidationFeedbackSection, activeValidationFeedbackData, handleAddCommentInFeedback, createNewValidationFeedback  } = this.props;
        const matrixCorrectAnswerCopy = JSON.parse(JSON.stringify(matrixOptionContent));
        const optionRight = _.get(matrixCorrectAnswerCopy, 'optionRight', {});
        const optionLeft = _.get(matrixCorrectAnswerCopy, 'optionLeft', {});
        // const lockData = _.get(formData, 'lockData')
        // let isLock = false
        // let message = ''
        // if (lockData) {
        //     isLock = lockData.isLock
        //     message = lockData.message
        // }

        return (
            <>
                <MyPATExpansionPanel
                    isDisable={this.props.isDisable}
                    hasExpandIcon
                    variant="white"
                    sectionId={this.props.sectionId} // used for scrolling to this section
                    customCollapseTitle={
                        <>
                        
                        <Typography variant="h6" className={classes.cardHeading} onClick={(event) => {
                            event.stopPropagation();
                            this.props.addFeedback('answer')}}>
                        <span
                        id={this.props.openFeedback && this.props.tag === "answer" ? 'feedbackScroll' : ''}
                        className={`${classes.feedbackContainer} ${this.props.openFeedback && this.props.tag === "answer" ? classes.blueColor : ''} ${this.props.openFeedback ? classes.feedbackHighlight : ''}`}
                        >Answer<span className={classes.requiredHeading}>*</span>
                            {this.props.openFeedback && this.props.tag === "answer" && (
                             <Grid className="feedbackBlock">
                             <AddFeedback 
                             author={this.props.authorType}
                             replyFeedback={this.props.replyFeedback} closeFeedback={this.props.closeFeedback} resolveFeedback={this.props.resolveFeedback} clickedfeedbackData={this.props.clickedfeedbackData} addNewFeedback={this.props.addNewFeedback} />
                           </Grid>)} 
                            {
                                activeValidationFeedbackSection === SECTIONS.ANSWER && (
                                <AddFeedbackPopup isAuthor={true} allowFeedbacks={true} handleAdd={handleAddCommentInFeedback} handleCancel={()=>createNewValidationFeedback && createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                                )
                            }
                           </span>
                           <CustomInfoIcon
                                infoDialogContentType="Goal Management"
                                isInfoIcon={true}
                                isRightArrow={false}
                                isCenterArrow={true}
                                knowMoreAbout={false}
                                dialogTitle="Answer"
                                imageURL="/assets/svg/infoIcon/answer.svg"
                                dialogPara="Specify the correct answer(s) to the question"
                                details="Click to know more"
                                toolTipDirection="top" />
                        </Typography>
                        </>
                    }
                    error={error}
                    errorText={errorText}
                >
                    <SectionFocusedContext.Consumer>
                        {({ setSectionFocus }: SectionFocusedContextValue) => (
                            <>
                            <div className={classes.borderBox}>
                                <Grid container
                                    justify="space-between"
                                    alignItems="center"                            
                                    spacing={8}>
                                    <Grid item>
                                        <Typography variant="subtitle1" className={classes.subTitle}>
                                            Set Correct Answer
                                                    </Typography>
                                    </Grid>
                                </Grid>
                                <Table className={classes.answerTable}>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>&nbsp;</TableCell>
                                            {_.map(optionRight, (optionR, idxR: number) => <TableCell key={idxR}>{idxR + 1}</TableCell>)}
                                        </TableRow>

                                        {_.map(optionLeft, (optionL, idxL: number) => (
                                            <TableRow key={idxL}>
                                                <TableCell>{optionsIdSet[idxL]}</TableCell>

                                                {_.map(optionRight, (optionR, idxR: number) => (
                                                    <TableCell key={`${idxL}-${idxR}`}>
                                                        <Checkbox
                                                            classes={{root: classes.checkBoxElement, 
                                                            checked: classes.checkedCheckbox,
                                                            colorPrimary: classes.primaryColor}}
                                                            checked={this.isChecked(optionL.id, optionR.id)}
                                                            onChange={this.handleCorrectOptionChange.bind(this, optionL.id, optionR.id)}
                                                            // classes={{ checked: classes.checkboxChecked }}
                                                        />
                                                    </TableCell>
                                                ))}

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>    
                            </div>
                            
                            
                            </>
                        )}
                    </SectionFocusedContext.Consumer>
                </MyPATExpansionPanel>
                {!hideIdealTIme && 
                
                <SetIdealTime
                  addFeedback={this.props.addFeedback}
                  openFeedback={this.props.openFeedback}
                  tag={this.props.tag}
                  idealTime={this.props.idealTime}
                  isDisable={isIdealTimeDisabled}
                  onChangeIdealTime={this.onChangeIdealTime}
                  checkFeedback={() => this.props.openFeedback && this.props.tag === "idealTime"}
                  authorType={this.props.authorType}
                  replyFeedback={this.props.replyFeedback}
                  closeFeedback={this.props.closeFeedback}
                  resolveFeedback={this.props.resolveFeedback}
                  clickedfeedbackData={this.props.clickedfeedbackData}
                  addNewFeedback={this.props.addNewFeedback}
                />
    }
            </>
        );
    }
};

// @ts-ignore
export default withStyles(styles)(MatrixAnswers);